import React, { useEffect } from 'react';
import { Field } from 'formik';
import cn from 'classnames';
import styles from "./index.module.scss";

const renderField = (props) => {
  const {
    field,
    type,
    readOnly,
    onChange,
    form: {
      touched,
      errors,
      submitCount,
      values
    },
    uniqueId,
    disabled,
    noErrorDisplay,
    getError
  } = props;

  useEffect(() => {
    if (noErrorDisplay && ((submitCount > 0) || (touched[field.name]))) {
      getError(errors[field.name]);
    }
    return () => {
      getError('');
    };
  }, [submitCount, errors]);
  return (
      <div className="custom-checkbox">
        <input
          {...field}
          type={type}
          readOnly={readOnly}
          id={uniqueId}
          checked={values[field.name] || false}
          disabled={disabled}
          // onClick={onClick}
          onChange={(e) => {
          field.onChange(e);
          if (onChange) onChange(e);
        }}
          style={{
            width: "20px",
            height: "20px",
          }}
          className={cn(styles.checkbox)}
        />
        {!noErrorDisplay && ((submitCount > 0)
        || (touched[field.name]
        && errors[field.name]))
          && (
          <div className="error">
            {errors[field.name]}
          </div>
          )}
      </div>
  );
};

const CheckBox = (props) => {
  const {
    name,
    errorLabel,
    label,
    readOnly,
    validate,
    customClass,
    defaultChecked,
    onChange,
    onClick,
    externalLabel,
    disabled,
    noErrorDisplay,
    getError
  } = props;
  return (
      <Field
        name={name}
        type="checkbox"
        readOnly={readOnly}
        component={renderField}
        label={label}
        errorLabel={errorLabel}
        validate={validate}
        customClass={customClass}
        uniqueId={`${externalLabel}_${name}_${label}`}
        defaultChecked={defaultChecked}
        onChange={onChange}
        onClick={onClick}
        disabled={disabled}
        noErrorDisplay={noErrorDisplay}
        getError={getError}
      />
  );
};
export default CheckBox;
